const isNotEmptyString = content => content.length > 0;
export const newlinesToParagraphs = content => {
  const splitContent = content.trim().split('\n');
  if (splitContent.length > 1) {
    return splitContent.filter(isNotEmptyString).map(line => `<p>${line}</p>`).join('');
  }
  return content.trim();
};
export function insertNodeAtEndOfHighlightedText(editor, newNode) {
  const bookmarkId = editor.selection.getBookmark().id;
  const endNode = editor.dom.get(`${bookmarkId}_end`);
  endNode.replaceWith(newNode);
  // Cleanup dom
  const startNode = editor.dom.get(`${bookmarkId}_start`);
  if (startNode) {
    editor.dom.remove(startNode);
  }
}